const normalizeText = value => (typeof value === 'string' ? value.trim() : '');

const getBackendCode = data =>
  normalizeText(data?.code) ||
  normalizeText(data?.display?.code) ||
  normalizeText(data?.error?.code);

const getBackendTitle = data => normalizeText(data?.display?.title) || normalizeText(data?.title);

const getBackendMessage = data =>
  normalizeText(data?.display?.message) ||
  normalizeText(data?.message) ||
  normalizeText(data?.error?.message) ||
  normalizeText(data?.display?.title);

export function buildScannerDisplayMessage(data, fallback = 'Scan processed.', options = {}) {
  const fallbackMessage = normalizeText(fallback) || 'Scan processed.';

  if (typeof data === 'string') {
    return normalizeText(data) || fallbackMessage;
  }

  if (!data || typeof data !== 'object') {
    return fallbackMessage;
  }

  const title = getBackendTitle(data);
  const message = getBackendMessage(data);
  const baseMessage =
    title && message && title !== message
      ? `${title}: ${message}`
      : message || title || fallbackMessage;
  const code = getBackendCode(data);

  if (options.includeCode && code && !baseMessage.includes(code)) {
    return `${baseMessage} (${code})`;
  }

  return baseMessage;
}
